export default __webpack_public_path__ + "static/media/avatarD2.cad4b752.png";